import { render, staticRenderFns } from "./iconUpload.vue?vue&type=template&id=6c4439d1"
import script from "./iconUpload.vue?vue&type=script&lang=js"
export * from "./iconUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports